import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Свободная экономическая зона "Брест"';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>

                    <p>Свободная экономическая зона «Брест» (СЭЗ «Брест») является первой в Республике Беларусь и официально функционирует с декабря 1996 года. Территория СЭЗ «Брест» состоит из двух участков, расположенных к северо-западу и востоку от города Бреста. Она охватывает площадь более 70 кв. км. На территории СЭЗ находится также международный аэропорт.</p>
                    <p>The Free economic zone «Brest» (FEZ «Brest») is the first FEZ in the Republic of Belarus. It has been functioning officially since December 1996. The territory of the FEZ «Brest» consists of two areas situated to the north-west and east of the city of Brest. It covers an area of over 70 km. An international airport is also located on the territory of the FEZ.</p>

                    <h4>Карты:</h4>
                    <ul>
                        <li>Карта - <a href={require('./../att/Maps/SEZ/01.swf')} download>SWF</a></li>
                    </ul>
                </div>
            </div>
        </>
    );
}